import React from 'react';
import { findDOMNode, render, unmountComponentAtNode } from 'react-dom';
import { Menu } from 'antd';
import classnames from 'classnames';
import { Checkbox, InputNumber, Tooltip } from '@platform/base';
import {
    getGlobalStorage,
    isNumber,
    setGlobalStorage,
    toast,
    getSysFieldid,
    microAppUtil,
} from '@platform/api';
import { setLocalStorageColumnsWidth, generateColSettingConfig } from '../../adapter/utils/handleProps';
import { isValidType } from '@platform/template';
import { getLocalStorageKey } from '../../adapter/utils';
import { getRawColumns, setColumns, resetWidths } from './requestUtil';
import ColSettingSide from './ColumnSetting';
import { getScrollBarSize } from '../../utils';

// import 'antd/es/menu/style/index.css';
// import 'antd/es/tooltip/style/index.css';
// import 'antd/es/dropdown/style/index.css';
// import 'antd/es/button/style/index.css';
// import 'antd/es/menu/style/css.js';
// import 'antd/es/dropdown/style/css.js';
import './index.less';

const scrollBarSize = getScrollBarSize();

const MENU_COPY = 'MENU_COPY';
const MENU_COPY_ROW = 'MENU_COPY_ROW';
const MENU_COPY_COL = 'MENU_COPY_COL';
const MENU_ADD_ROW_UP = 'MENU_ADD_ROW_UP';
const MENU_ADD_ROW_DOWN = 'MENU_ADD_ROW_DOWN';
const MENU_DEL_ROW = 'MENU_DEL_ROW';
const MENU_AUTO_WRAP = 'MENU_AUTO_WRAP';
const MENU_SAVE_COL_WIDTH = 'MENU_SAVE_COL_WIDTH';
const MENU_RESET = 'MENU_RESET';
const MENU_COL_SETTING = 'MENU_COL_SETTING';
const MENU_COL_SETTING_SAVE = 'MENU_COL_SETTING_SAVE';

const { Item, SubMenu, Divider } = Menu;

const showSuccessToast = msg => toast({ content: msg, light: true });

function useContextMenu(Table) {
    return class MenuTable extends React.Component {

        state = {
            rowInfo: {},
            colInfo: {},
            addUpNum: 1,
            addDownNum: 1,
            showColSetting: false,
            hasScrollBar: false,
        }

        info = {
            rowInfo: {},
            colInfo: {},
        };

        componentDidMount() {
            document.addEventListener('click', this.handleOutsideClick);
        }

        render() {
            let { columns = [], contextMenuConfig = {}, store, rowHeight, id, currentId, flex, locale, _onScrollBarStatusChange, pageScope, _runContext, isInnerFlatButton, relationMetaId } = this.props;
            let { showColSetting, hasScrollBar } = this.state;
            let titleDepth = 1;
            const {
                enable,
                disableArea,
                hiddenLeftItem,
                cancelCustomRightMenu = true,
                onClick,
            } = contextMenuConfig;
            //列设置居中功能，不好看，先去掉。
            // (function calcTitleDepth (cols = columns) {
            //     for(let i=0; i<cols.length; i++) {
            //         if(cols[i].hasOwnProperty('childLeafNodes')) {
            //             titleDepth +=1;
            //             calcTitleDepth(cols[i].childLeafNodes);
            //             return;
            //         } 
            //     }
            // })();

            return <>
                <div
                    className={classnames('context-menu-container', { 'flex-container': flex })}
                    onContextMenu={enable && this.handleContextMenuShow}
                    onKeyDown={event => {
                        let key = event.keyCode || event.charCode || event.which,
                            activeCell = store.getActiveCell();

                        if (key === 67 && (event.metaKey || event.ctrlKey) && !document.getSelection().toString()) {
                            // ctrl + c
                            let selectedCell = store.getSelectedCell(),
                                content = this.getCopyText(selectedCell);

                            store.setCopiedCell(selectedCell);
                            store.copy(content);
                        }
                    }}
                >
                    {<ColSettingSide
                        show={showColSetting}
                        onClose={this.hideColSettingSide}
                        store={store}
                        ref={ref => this.colSettingRef = ref}
                        id={relationMetaId || id}
                        relationMetaId={relationMetaId}
                        currentId={currentId}
                        cancelCustomRightMenu={cancelCustomRightMenu}
                        hiddenLeftItem={hiddenLeftItem}
                        tableBody={findDOMNode(this)}
                        wrapStatus={getAutoWrap(store, relationMetaId || id)}
                        onWrapChange={this.handleWrapChange}
                        locale={locale}
                        pageScope={pageScope}
                        onSave={() => {
                            onClick?.(MENU_COL_SETTING_SAVE);
                        }}
                    />
                    }
                    <Table
                        {...this.props}
                        columns={columns}
                        colSettingMethod={{
                            onLockCol: this.colSettingRef?.handleRightLockCol,
                            onUnlockCol: this.colSettingRef?.handleRightUnLockCol,
                            onHiddenCol: this.colSettingRef?.hiddenCol,
                            renderContent: this.colSettingRef?.renderContent,
                            handleSave: this.colSettingRef?.handleSave,
                        }}
                        cellProps={(rowInfo, colInfo) => {
                            let otherProps = this.props.cellProps?.(rowInfo, colInfo) || {};
                            return {
                                ...otherProps,
                                onContextMenu: e => {
                                    let disabled = disableArea?.(rowInfo?.row?.key, colInfo?.col?.key);
                                    if (disabled) {
                                        e.stopPropagation();
                                    } else {
                                        this.info = { rowInfo, colInfo };
                                        this.setState({ rowInfo, colInfo });
                                    }

                                    otherProps?.onContextMenu?.(e);
                                },
                            };
                        }}
                        _onScrollBarStatusChange={status => {
                            // 滚动条状态变化触发（是否有滚动条）
                            this.setState({ hasScrollBar: status });
                            _onScrollBarStatusChange?.(status);
                        }}
                    />
                    {!cancelCustomRightMenu &&
                        <Tooltip
                            placement="top"
                            overlay={locale['table0053'] /*列表设置*/}
                            delayHide={1}
                            delayShow={1000}
                        ><i
                                className="header-icon col-setting-icon"
                                style={{
                                    marginRight: hasScrollBar ? scrollBarSize : 0,
                                    height: rowHeight * titleDepth,
                                    top: isInnerFlatButton ? '35px' : '1px',
                                }}
                            >

                                <i className='iconfont icon-lbsz' onClick={this.showColSettingSide} />
                            </i>
                        </Tooltip>}
                </div>
            </>;
        }

        componentWillUnmount() {
            this.handleContextMenuClose();
            document.removeEventListener('click', this.handleOutsideClick);
        }

        getCopyText = selectedCell => {
            let { store } = this.props;
            let content = [...selectedCell].map(([selectedRowKey, columns]) =>
                // columns是set 需要转数组
                [...columns].map(selectedColKey => {
                    let itemtype = store.getColumnProps(selectedColKey, 'itemtype'),
                        text = '';

                    if (selectedRowKey == -1) {
                        text = store.getColumnProps(selectedColKey, 'label');
                    } else if (itemtype === "number") {
                        text = store.getCellValue(selectedRowKey, selectedColKey).value || '';
                    } else {
                        text = store.getCellValue(selectedRowKey, selectedColKey)._display_ || '';
                    }

                    text = this.formatCopyText(text);

                    return text;

                }).join('\t'),
            ).join('\r');

            return content;
        }

        formatCopyText = text => {
            if (!text) {
                return '';
            }
            // excel单元格内容带\n时，粘贴时前后带"；单元格内容带"时，转为两个"，这里是反过来的
            if (text.includes('\n')) {
                text = text.replaceAll('"', '""');
                text = `"${text}"`;
            }
            return text;
        }

        handleContextMenuShow = event => {
            this.handleContextMenuClose();

            if (!event.currentTarget.contains(event.target) || !event.target.matches('.base-table-next .table-next-body-cell *, .base-table-next .table-next-header-cell *')) {
                return;
            }

            event.preventDefault();

            let { contextMenuConfig = {}, store, id, currentId, locale } = this.props;
            let tableId = currentId || id;
            let { addUpNum, addDownNum } = this.state,
                { rowInfo, colInfo } = this.info;
            const {
                extendRightMenu,
                extendRightMenuPlacement = 'bottom',
                rightMenuClick,
                cancelCustomRightMenu = true,
                onVisibleChange,
                disabled = new Set(),
                showWidthAndHeightConfig = true,
                columnWidthConfig,
                hiddenDelRow,
            } = contextMenuConfig;

            let showRowMenu = store.getStatus() === 'edit' && typeof rightMenuClick === 'function';

            let div = document.createElement('div');
            div.style.position = 'fixed';
            div.style.zIndex = '1250'; // 要比fieldSetting的高 YBP-CCF-BUG-2288

            microAppUtil.getDocument().appendChild(div);

            this.contextMenuContainer = div;

            render(<div
                className='context-menu-dropdown'
                onMouseDown={event => {
                    event.stopPropagation();
                }}
            >
                <Menu
                    fieldid={getSysFieldid("column-right")}
                    mode="vertical"
                    onClick={this.handleMenuClick}
                    subMenuCloseDelay={0.5}
                >
                    {extendRightMenuPlacement === 'top' && <div onClick={this.handleMenuClick}>{extendRightMenu?.({
                        rowIndex: rowInfo?.row?.dataIndex,
                        attrcode: colInfo?.col?.key,
                        column: colInfo?.col,
                        record: rowInfo?.row,
                    }) || ''}</div>}
                    {isValidType(colInfo?.col?.itemtype) && <Item fieldid={getSysFieldid("column-right-copy")} key={MENU_COPY}>{locale['table_copy'] /*复制*/}</Item>}
                    <Item fieldid={getSysFieldid("column-right-copy-line")} key={MENU_COPY_ROW}>{locale['table_copy-row'] /*复制行信息*/}</Item>
                    {isValidType(colInfo?.col?.itemtype) && <Item fieldid={getSysFieldid("column-right-copy-col")} key={MENU_COPY_COL}>{locale['table_copy-column'] /*复制列信息*/}</Item>}
                    {(showRowMenu || showWidthAndHeightConfig || !cancelCustomRightMenu) && <Divider />}
                    {showRowMenu && <>
                        <Item fieldid={getSysFieldid("column-right-insert-up")} key={MENU_ADD_ROW_UP} className='item-input'>
                            {locale['table_insert_up'] /*向上增行*/}
                            <InputNumber
                                onChange={value => {
                                    if (!isNumber(+value)) { return; }
                                    this.setState({ addUpNum: +value });
                                }}
                                value={addUpNum || 1}
                                onClick={e => e.stopPropagation()}
                            />
                        </Item>
                        <Item fieldid={getSysFieldid("column-right-insert-down")} key={MENU_ADD_ROW_DOWN} className='item-input' >
                            {locale['table_insert_down'] /*向下增行*/}
                            <InputNumber
                                onChange={value => {
                                    if (!isNumber(+value)) { return; }
                                    this.setState({ addDownNum: +value });
                                }}
                                value={addDownNum || 1}
                                onClick={e => e.stopPropagation()}
                            />
                        </Item>
                        <Divider />
                        {!hiddenDelRow && <Item fieldid={getSysFieldid("column-right-del-row")} key={MENU_DEL_ROW}>{locale['table_delete'] /*删除行*/}</Item>}
                        <Divider />
                    </>}
                    {showWidthAndHeightConfig &&
                        <>
                            {!disabled.has(MENU_AUTO_WRAP) && <Item fieldid={getSysFieldid("column-right-auto-wrap")} key={MENU_AUTO_WRAP}
                                className={classnames({
                                    'subtitle-col-width': true,
                                    'subtitle-col-width-bg': getAutoWrap(store, tableId),
                                })}
                            >
                                <span>{locale['auto_wrap'] /*自动换行*/}</span>
                                <i className={classnames({
                                    'iconfont': true,
                                    'icon-liucheng1': true,
                                    'check-mark': getAutoWrap(store, tableId),
                                    'disable-check-mark': !getAutoWrap(store, tableId),
                                })} />
                            </Item>}
                            {!cancelCustomRightMenu && columnWidthConfig && <Item fieldid={getSysFieldid("column-right-save-col")} className='subtitle-col-width' key={MENU_SAVE_COL_WIDTH}>{locale['save_width'] /*保存列宽*/}</Item>}
                            {!cancelCustomRightMenu && columnWidthConfig && <Item fieldid={getSysFieldid("column-right-reset-col")} className='subtitle-col-width' key={MENU_RESET}>{locale['table0055'] /*重置列宽*/}</Item>}
                            <Divider className='width-height-bottom' />
                        </>
                    }
                    {!cancelCustomRightMenu && <Item fieldid={getSysFieldid("column-right-col-setting")} key={MENU_COL_SETTING}>{locale['menu_column_setting'] /*列表设置*/}</Item>}
                    {extendRightMenuPlacement === 'bottom' && <div onClick={this.handleMenuClick}>{extendRightMenu?.({
                        rowIndex: rowInfo?.row?.dataIndex,
                        attrcode: colInfo?.col?.key,
                        column: colInfo?.col,
                        record: rowInfo?.row,
                    }) || ''}</div>}
                </Menu>
            </div>, div);

            this.setState({ addDownNum: 1, addUpNum: 1 });
            onVisibleChange?.(true);

            this.setPosition(event, div);
        }

        handleContextMenuClose = () => {
            if (this.contextMenuContainer) {
                let { contextMenuConfig = {} } = this.props,
                    { onVisibleChange } = contextMenuConfig;

                unmountComponentAtNode(this.contextMenuContainer);
                let appDom = microAppUtil.getDocument();
                appDom.removeChild(this.contextMenuContainer);
                this.contextMenuContainer = null;

                this.setState({ addDownNum: 1, addUpNum: 1 });
                onVisibleChange?.(false);
            }
        }

        handleOutsideClick = event => {
            if (!this.contextMenuContainer?.contains(event.target)) {
                this.handleContextMenuClose();
            }
        }

        // 抄的以前代码
        setPosition = (event, container) => {
            // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
            const clickX = event.clientX;
            const clickY = event.clientY;
            // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
            const screenW = window.innerWidth;
            const screenH = window.innerHeight;
            // 获取自定义菜单的宽度/高度
            const rootW = container.offsetWidth;
            const rootH = container.offsetHeight;

            // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
            // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
            const right = screenW - clickX > rootW;
            const left = !right;
            const bottom = screenH - clickY > rootH;
            const top = !bottom;
            if (right) {
                container.style.left = `${clickX}px`;
            }
            if (left) { container.style.left = `${clickX - rootW}px`; }
            if (bottom) { container.style.top = `${clickY}px`; }
            if (top) {
                if (clickY - rootH < 70) { //70 = 导航栏+内部页签的高度  小于70也会展示不全，按UE要求下移 YBP-FI-BUG-3987
                    container.style.top = `70px`;
                } else {
                    container.style.top = `${clickY - rootH}px`;
                }
            }
            if (screenW - clickX < 110 + 32) {
                container.classList.add('nearRight');
            }
        }

        handleMenuClick = ({ key }) => {
            const { store, rows, contextMenuConfig = {}, id, currentId } = this.props;
            const { rowInfo, colInfo, addUpNum, addDownNum } = this.state;

            let { onClick, rightMenuClick } = contextMenuConfig;

            onClick?.(key);

            this.handleContextMenuClose();

            let rowKey = rowInfo.row?.key;
            let colKey = colInfo.col?.key;
            let selectedItemType = colInfo.col?.itemtype;
            let disabledColKey = ['CHECKBOX', 'INDEX', 'opr'];
            let copyColumns = colInfo.columns?.filter(col => !disabledColKey.includes(col.key));
            // 判断有没有框选范围
            let selectedCell = store.getSelectedCell();
            let checkedKeys = store.getCheckedKeys();
            let copyCell = new Map();
            switch (key) {
                // 复制
                case MENU_COPY:
                    if (!rowKey || !colKey) { return; }

                    let content = '';

                    // 判断有没有框选范围, 且右键位置在框选范围内
                    if (selectedCell?.size && selectedCell.get(rowKey)?.has(colKey)) {
                        // selectedCell是map 需要转数组
                        content = this.getCopyText(selectedCell);
                        //存储复制的单元格信息 
                        store.setCopiedCell(selectedCell);
                    } else {
                        // 不在框选范围内，复制单元格内容，且仅选中此单元格
                        if (rowKey == -1) {
                            content = store.getColumnProps(colKey, 'label');
                        } else if (selectedItemType === "number") {
                            content = store.getCellValue(rowKey, colKey).value || '';
                        } else {
                            content = store.getCellValue(rowKey, colKey)._display_ || '';
                        }

                        content = this.formatCopyText(content);

                        store.setCopiedCell(new Map([[rowKey, new Set([colKey])]]));
                    }
                    store.copy(content);

                    break;
                // 复制行
                case MENU_COPY_ROW:
                    if (!rowKey) { return; }
                    let rowDisplay = '';
                    //如果复制的当前行是勾选行
                    if (checkedKeys.has(rowKey)) {
                        rowDisplay = [...checkedKeys].map(checkedRowKey => {
                            let copyColKey = new Set();
                            let result = copyColumns.map(col => {
                                copyColKey.add(col.key);

                                let text = '';

                                if (checkedRowKey == -1) {
                                    text = store.getColumnProps(col.key, 'label');
                                } else if (col.itemtype === "number") {
                                    text = store.getCellValue(checkedRowKey, col.key)?.value || '';
                                } else {
                                    text = store.getCellValue(checkedRowKey, col.key)?._display_ || '';
                                }

                                text = this.formatCopyText(text);

                                return text;
                            }).join('\t');
                            copyCell.set(checkedRowKey, copyColKey);
                            return result;
                        },
                        ).join('\r');
                        store.setCopiedCell(copyCell);
                    } else if (selectedCell?.size && (colKey && selectedCell.get(rowKey)?.has(colKey) || !colKey && selectedCell.get(rowKey))) {
                        // 判断有没有框选范围, 且右键位置在框选范围内 没有列key 那么复制框选的行，有列，要判断是不是在框选范围内
                        rowDisplay = [...selectedCell].map(([selectedRowKey]) => {
                            let copyColKey = new Set();
                            // colInfo.columns是array 不需要转数组
                            let result = copyColumns.map(col => {
                                copyColKey.add(col.key);

                                let text = '';

                                if (selectedRowKey == -1) {
                                    text = store.getColumnProps(col.key, 'label');
                                } else if (col.itemtype === "number") {
                                    text = store.getCellValue(selectedRowKey, col.key)?.value || '';
                                } else {
                                    text = store.getCellValue(selectedRowKey, col.key)?._display_ || '';
                                }
                                
                                text = this.formatCopyText(text);

                                return text;
                            }).join('\t');
                            copyCell.set(selectedRowKey, copyColKey);
                            return result;
                        }).join('\r');
                        store.setCopiedCell(copyCell);
                    } else { //复制当前行
                        let copyColKey = new Set();
                        rowDisplay = copyColumns.map(col => {
                            copyColKey.add(col.key);

                            let text = '';

                            if (rowKey == -1) {
                                text = store.getColumnProps(col.key, 'label');
                            } else if (col.itemtype === "number") {
                                text = store.getCellValue(rowKey, col.key)?.value || '';
                            } else {
                                text = store.getCellValue(rowKey, col.key)?._display_ || '';
                            }

                            text = this.formatCopyText(text);

                            return text;
                        }).join('\t');
                        copyCell.set(rowKey, copyColKey);
                        store.setCopiedCell(copyCell);
                    }
                    store.copy(rowDisplay);
                    break;
                // 复制列
                case MENU_COPY_COL:
                    if (!colKey) { return; }

                    let colDisplay = '';

                    // selectedCell是map 需要转数组 拿到第一行的列数据即可
                    let columns = selectedCell?.size && [...selectedCell][0]?.[1] ? [...selectedCell][0][1] : new Set();
                    // 判断有没有框选范围, 且右键位置在框选范围内 没有行key 那么复制框选的列，有行key, 要判断是不是在框选范围内
                    if (selectedCell?.size && (rowKey && selectedCell.get(rowKey)?.has(colKey) || !rowKey && columns.has(colKey))) {
                        // columns是set 也需要转数组
                        colDisplay = rows.map(row => {
                            let copyColKey = new Set();
                            let result = [...columns].map(selectedColKey => {
                                copyColKey.add(selectedColKey);

                                let text = '';

                                let currentItemType = store.getColumnProps(selectedColKey, 'itemtype');
                                if (currentItemType === "number") {
                                    text = store.getCellValue(row.key, selectedColKey)?.value || '';
                                } else {
                                    text = store.getCellValue(row.key, selectedColKey)?._display_ || '';
                                }

                                text = this.formatCopyText(text);

                                return text;
                            }).join('\t');
                            copyCell.set(row.key, copyColKey);
                            return result;
                        },
                        ).join('\r');
                        store.setCopiedCell(copyCell);
                    } else { //复制某一列
                        colDisplay = rows.map(row => {
                            copyCell.set(row.key, new Set([colKey]));

                            let text = '';

                            let currentItemType = store.getColumnProps(colKey, 'itemtype');
                            if (currentItemType === "number") {
                                text = store.getCellValue(row.key, colKey)?.value || '';
                            } else {
                                text = store.getCellValue(row.key, colKey)?._display_ || '';
                            }

                            text = this.formatCopyText(text);

                            return text;
                        }).join('\r');
                        store.setCopiedCell(copyCell);
                    }
                    store.copy(colDisplay);
                    break;
                // 向上增行
                case MENU_ADD_ROW_UP:
                    if (addUpNum <= 0) { return; }
                    let upRows = [...new Array(addUpNum)].map(() => ({ values: {} }));
                    store.addRow(rowInfo.rowIndex/* viewIndex */, upRows);
                    typeof rightMenuClick === 'function' && rightMenuClick('insert_up', addUpNum, rowInfo.rowIndex/* viewIndex */, { tableId: id }, rowInfo);
                    break;
                // 向下增行
                case MENU_ADD_ROW_DOWN:
                    if (addDownNum <= 0) { return; }
                    let downRows = [...new Array(addDownNum)].map(() => ({ values: {} }));
                    store.addRow(rowInfo.rowIndex/* viewIndex */ + 1, downRows);
                    typeof rightMenuClick === 'function' && rightMenuClick('insert_down', addDownNum, rowInfo.rowIndex/* viewIndex */ + 1, { tableId: id }, rowInfo);
                    break;
                // 删行
                case MENU_DEL_ROW:
                    if (!rowKey) { return; }

                    checkedKeys.delete(rowKey);
                    store.setCheckedKeys(checkedKeys);
                    store.deleteRow(rowKey);
                    typeof rightMenuClick === 'function' && rightMenuClick('delete', 1, rowInfo.rowIndex/* viewIndex */, { tableId: id }); //TODO 暴露给业务的index是不是要转成dataIndex
                    break;
                // 自动换行
                case MENU_AUTO_WRAP:
                    this.handleWrapChange(!getAutoWrap(store, currentId));
                    break;
                // 保存列宽
                case MENU_SAVE_COL_WIDTH:
                    this.handleSaveWidthSelect();
                    break;
                // 重置列宽
                case MENU_RESET:
                    this.handleResetWidthSelect();
                    break;
                // 列设置
                case MENU_COL_SETTING:
                    this.showColSettingSide();
                    break;
            }
        }

        /**
         * 重置列宽
         *  - 需要更新界面
         */
        handleResetWidthSelect = () => {
            let { store, id: mainId, locale } = this.props,
                { tableId, tableType } = store.getFlatInfo?.() || {},
                id = tableType === "flat" ? tableId : mainId;
            resetWidths(store, id).then(res => {
                if (res.success) {
                    return getRawColumns(store, id);
                }
            }).then(res => {
                // 获取模板并设置列宽
                res.data[0].areas[id].items
                    .forEach(col => {
                        store.setColumnProps(
                            col.code,
                            { width: parseInt(col.width) || store.getInstance()._getDefaultWidth(col.itemtype) },
                            { shouldUpdate: false },
                        );
                    });

                // 清除localStorage里的列宽信息
                setLocalStorageColumnsWidth(store, id, null);
                store.resetColumnsWidth();

                store.forceUpdate();

                showSuccessToast(`${locale['colwidth_reset_success'] /*列宽重置成功*/}`);
            });
            this.setState({ showColSetting: false });
        }

        /**
         * 保存列宽
         *  - 不需要更新界面
         */
        handleSaveWidthSelect = () => {
            let { store, id: mainId, locale } = this.props,
                { tableId, tableType } = store.getFlatInfo?.() || {},
                widths = store.getColumnsWidth(),
                id = tableType === "flat" ? tableId : mainId;

            if (!widths || !Object.keys(widths).length) { //没有改变
                showSuccessToast(`${locale['colwidth_set_success'] /*列宽保存成功*/}`);
                return;
            }

            getRawColumns(store, id).then(res => {
                if (res.success) {
                    let columns = res.data[1][id].items.map(col => ({ ...col, key: col.attrcode }));
                    // 保存列宽
                    columns = columns.map(col => {
                        if (widths[col.key]) {
                            col.width = String(widths[col.key]);
                        }
                        return col;
                    });

                    return setColumns(store, id, columns);
                }
            }).then(res => {
                if (res.success) {
                    // 保存列宽到localStorage
                    let columns = store.getColumns();
                    let columnsMap = {};
                    columns.forEach(col => columnsMap[col.key] = col);
                    let savedWidths = {};
                    Object.keys(widths).filter(colKey => !isValidType(columnsMap[colKey]?.itemtype)).forEach(colKey => savedWidths[colKey] = widths[colKey]);
                    if (!savedWidths || !Object.keys(savedWidths).length) { return; }

                    setLocalStorageColumnsWidth(store, id, savedWidths);

                    showSuccessToast(`${locale['colwidth_set_success'] /*列宽保存成功*/}`);
                }
            });
        }

        handleWrapChange = value => {
            const { store, id, contextMenuConfig } = this.props;
            let { tableType, tableId } = store.getFlatInfo?.() || {};
            if (tableType == "flat") {
                setAutoWrap(store, tableId, value);
            } else {
                setAutoWrap(store, id, value);
            }
            contextMenuConfig?.onClick?.(MENU_AUTO_WRAP);
        }

        showColSettingSide = () => {
            this.setState({ showColSetting: true });
        }

        hideColSettingSide = () => {
            this.setState({ showColSetting: false });
        }
    };
}

useContextMenu.propsGenerator = function (props) {
    let { store, id, contextMenuConfig = {} } = props;
    let pageId = generateColSettingConfig(store, id).pageId;
    let { cancelCustomRightMenu } = contextMenuConfig;
    return {
        ...props,
        contextMenuConfig: {
            ...props.contextMenuConfig,
            cancelCustomRightMenu: pageId ? cancelCustomRightMenu : true,
        },
    };
};

useContextMenu.displayName = 'useContextMenu';
useContextMenu.dependence = [];

export default useContextMenu;

export function setAutoWrap(store, id, flag) {
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag');
    if (savedValue) {
        savedValue = JSON.parse(savedValue);
    } else {
        savedValue = {};
    }
    savedValue = {
        ...savedValue,
        [savedKey]: flag,
    };

    setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(savedValue));
}

export function getAutoWrap(store, id, originValue) {
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag') || {};
    if (typeof savedValue === 'string') {
        savedValue = JSON.parse(savedValue);
    }
    if (originValue) { //不转化
        return savedValue?.[savedKey];
    }
    return !!savedValue?.[savedKey];
}